export const FIELD_KEYS = {
  // ─── About You ────────────────────────────────────────────────────────────
  // FIELDS-NAME-1 (s135): name captured as parts; full_legal_name is DERIVED (store-on-save)
  // and kept as an active-but-non-input field until the ISP field_map rebind retires it.
  FIRST_NAME:                             'first_name',
  MIDDLE_NAME:                            'middle_name',
  FAMILY_NAME:                            'family_name',
  SURNAME:                                'surname', // BENEFICIARY-FILL-1 (s156): children-overview name split
  NAME_AT_BIRTH:                          'name_at_birth',
  COUNTRY_OF_BIRTH:                       'country_of_birth', // s147
  PROVINCE_OF_BIRTH:                      'province_of_birth', // s222 LANE-2: the interview's facts screen
  MOTHER_MAIDEN_NAME:                     'mother_maiden_name', // s222 LANE-2: the interview's facts screen (About You; not mothers_full_maiden_name)
  // s223 (D-222.8): the interview's `you` screen.
  MOBILE:                                 'mobile',
  PHONE_MAKE_MODEL:                       'phone_make_model',
  OTHER_EMAILS:                           'other_emails',
  FULL_LEGAL_NAME:                        'full_legal_name',
  DATE_OF_BIRTH:                          'date_of_birth',
  PLACE_OF_BIRTH:                         'place_of_birth',
  MARITAL_STATUS:                         'marital_status',
  HOME_ADDRESS:                           'home_address',
  HAS_CHILDREN:                           'hasChildren',
  OWNS_BUSINESS:                          'owns_business',
  HAS_PETS:                               'hasPets',
  OWNS_PROPERTY:                          'owns_property',
  WORK_SITUATION:                         'work_situation',
  HOME_TENURE:                            'home_tenure',
  HAS_FIREARMS:                           'hasFirearms', // s119 capture-only flag (no section gating)
  HAS_VETERANS_SERVICE:                   'hasVeteransService', // s171 R-A capture-only flag (no section gating)
  PHONE_UNLOCK:                           'phone_unlock',
  PRIMARY_EMAIL_PASSWORD:                 'primary_email_password',
  // s234 part 5 (D-234.49–.52): Protect Your Access's typed fields, and its retired phone_location (D-196.1).
  PRIMARY_EMAIL:                          'primary_email',
  SECURE_FILE_LOCATION:                   'secure_file_location',
  PHONE_LOCATION:                         'phone_location',

  // ─── Executor info ────────────────────────────────────────────────────────
  ALTERNATE_EXECUTOR:                     'alternate_executor',
  ESTATE_ACCOUNTANT:                      'estate_accountant',
  ESTATE_FINANCIAL_ADVISOR:               'estate_financial_advisor',
  ESTATE_LAWYER:                          'estate_lawyer',
  EXEC_ADDRESS:                           'exec_address',
  EXEC_EMAIL:                             'exec_email',
  EXEC_NAME:                              'exec_name',
  EXEC_NOTES:                             'exec_notes',
  EXEC_PHONE:                             'exec_phone',
  EXEC_RELATIONSHIP:                      'exec_relationship',
  ACCESS_LEVEL:                           'access_level', // s156 G (ruling 10): gates the executor invite
  EXEC_ROLE:                              'exec_role',
  TOLD:                                   'told', // s223 (D-222.10): legal-your-executor — told / not told
  PET_GUARDIAN:                           'pet_guardian',

  // ─── Executor Ontario checklist ───────────────────────────────────────────
  APPLY_CPP_DEATH_BENEFIT:                'apply_cpp_death_benefit',
  CANCEL_CPP_OAS:                         'cancel_cpp_oas',
  CANCEL_DRIVERS_LICENCE:                 'cancel_drivers_licence',
  CANCEL_ODB:                             'cancel_odb',
  CANCEL_OHIP:                            'cancel_ohip',
  CANCEL_ONTARIO_TRILLIUM:                'cancel_ontario_trillium',
  CANCEL_SUBSCRIPTIONS:                   'cancel_subscriptions',
  CONTACT_ESTATE_LAWYER_PROBATE:          'contact_estate_lawyer_probate',
  FILE_LIFE_INSURANCE_CLAIMS:             'file_life_insurance_claims',
  NOTIFY_BENEFICIARIES:                   'notify_beneficiaries',
  NOTIFY_CANADA_POST:                     'notify_canada_post',
  NOTIFY_CRA:                             'notify_cra',
  NOTIFY_EMPLOYER:                        'notify_employer',
  ORDER_DEATH_CERTIFICATES:               'order_death_certificates',
  SECURE_ALL_ASSETS:                      'secure_all_assets',
  SETUP_ESTATE_BANK_ACCOUNT:              'setup_estate_bank_account',

  // ─── Executor tasks / roadmap ─────────────────────────────────────────────
  ACTION:                                 'action',
  COMPLETED:                              'completed',
  DONE:                                   'done',
  EXECUTOR_INSTRUCTIONS:                  'executor_instructions',
  EXECUTOR_INSTRUCTIONS_ESTATE_ROADMAP:   'executor-instructions-estate-roadmap',
  FORM_DOC:                               'form_doc',
  TASK:                                   'task',
  TIMING:                                 'timing',
  WEBSITE:                                'website',

  // ─── Personal identity ────────────────────────────────────────────────────
  FATHERS_FULL_NAME:                      'fathers_full_name',
  HEALTH_CARD_NUMBER:                     'health_card_number',
  LAST_OCCUPATION:                        'last_occupation',
  MARRIAGE_DATE:                          'marriage_date',
  COHABITATION_START_DATE:                'cohabitation_start_date', // FIELD-AUDIT-1 (D-154.12)
  SEPARATION_DATE:                        'separation_date',         // FIELD-AUDIT-1 (D-154.12)
  MARRIAGE_LOCATION:                      'marriage_location',
  MOTHERS_FULL_MAIDEN_NAME:               'mothers_full_maiden_name',
  PI_FIELD:                               'pi_field',
  PI_NOTES:                               'pi_notes',
  PI_VALUE:                               'pi_value',
  SOCIAL_INSURANCE_NUMBER:                'social_insurance_number',
  SPOUSE_DOB:                             'spouse_dob',
  SPOUSE_NAME:                            'spouse_name',

  // ─── Legal / POA ──────────────────────────────────────────────────────────
  ATTORNEY:                               'attorney',
  BENEFICIARY_ADDRESS:                    'beneficiary_address',
  BENEFICIARY_ASK_FOR:                    'beneficiary_ask_for',
  BENEFICIARY_ASK_FOR_PHONE:              'beneficiary_ask_for_phone',
  BENEFICIARY_ASK_FOR_EMAIL:              'beneficiary_ask_for_email',
  BENEFICIARY_ASK_FOR_ADDRESS:            'beneficiary_ask_for_address',
  BENEFICIARY_EMAIL:                      'beneficiary_email',
  // BENEFICIARY-FILL-1 (s156): beneficiary_full_name retired-and-reminted → first_name + surname.
  BENEFICIARY_FIRST_NAME:                 'beneficiary_first_name',
  BENEFICIARY_SURNAME:                    'beneficiary_surname',
  BENEFICIARY_PHONE:                      'beneficiary_phone',
  BENEFICIARY_RELATIONSHIP:               'beneficiary_relationship',
  BENEFICIARY_SHARE:                      'beneficiary_share',
  // s223 (D-222.10 part 4): the interview's `benef` screen.
  BENEFICIARY_DOB:                        'beneficiary_dob',
  BENEFICIARY_TYPE:                       'beneficiary_type',
  BENEFICIARY_MINOR:                      'beneficiary_minor',
  BENEFICIARY_TILE:                       'beneficiary_tile',
  BENEFICIARY_WHO_THEY_ARE:               'beneficiary_who_they_are', // s223 (D-223.19): the typed lead
  // s228 Person pilot: the beneficiary and child-trustee keys the translation layer maps.
  BENEFICIARY_CLASS:                      'beneficiary_class',
  NAME_IN_WILL:                           'name_in_will',
  TRUSTEE:                                'trustee',
  TRUSTEE_ADDRESS:                        'trustee_address',
  TRUSTEE_PHONE:                          'trustee_phone',
  TRUSTEE_EMAIL:                          'trustee_email',
  GUARDIAN_COMP:                          'guardian_comp',
  INHERITANCE_INSTRUCTIONS:               'inheritance_instructions',
  CODICILS:                               'codicils',
  DATE_EXECUTED:                          'date_executed',
  POA_TYPE:                               'poa_type',
  SUBSTITUTE_ATTORNEY:                    'substitute_attorney',
  TESTAMENTARY_TRUST:                     'testamentary_trust',
  WILL_DATE_SIGNED:                       'will_date_signed',
  WILL_PREPARED_BY_LAWYER:                'will_prepared_by_lawyer',

  // ─── Probate ──────────────────────────────────────────────────────────────
  CEMETERY_PLOT:                          'cemetery_plot',
  CPP_DEATH_BENEFIT:                      'cpp_death_benefit',
  FOREIGN_ASSETS:                         'foreign_assets',
  INS_POLICY_NUM:                         'ins_policy_num',
  INTELLECTUAL_PROPERTY:                  'intellectual_property',
  JOINT_ACCOUNT_HOLDERS:                  'joint_account_holders',
  LOANS_RECEIVABLE:                       'loans_receivable',
  NAMED_BENEFICIARY_DESIGNATIONS:         'named_beneficiary_designations',
  RRIF_DETAILS:                           'rrif_details',

  // ─── Financial — bank accounts ────────────────────────────────────────────
  ACCOUNT_NUM:                            'account_num',
  ACCOUNT_TYPE:                           'account_type',
  BALANCE:                                'balance',
  BANK:                                   'bank',
  BRANCH:                                 'branch',

  // ─── Financial — investments ──────────────────────────────────────────────
  INV_TYPE:                               'inv_type',
  INSTITUTION:                            'institution',
  MARKET_VALUE:                           'market_value',
  // s229 D-229.111: the FinancialAccount sections' ownership, joint owner and beneficiary designation.
  OWNERSHIP:                              'ownership',
  JOINT_OWNER_NAME:                       'joint_owner_name',
  DESIGNATED_BENEFICIARY:                 'designated_beneficiary',
  BENEFICIARY_NAME:                       'beneficiary_name',

  // ─── Financial — recurring services & auto-pay (PADS) ────────────────────
  // s217: the Statement Scanner's `bulk-add` writes into this section and resolves its
  // target fields through these declared keys, never a display-name substring.
  SERVICE_NAME:                           'service_name',

  // ─── Financial — income / debt / tax ─────────────────────────────────────
  AMOUNT:                                 'amount',
  CREDITOR:                               'creditor',
  DEBT_TYPE:                              'debt_type',
  DEBT_INSURED:                           'debt_insured',      // s231 FinancialObligation
  IS_AUTOPAY:                             'is_autopay',        // s231
  PAYMENT_METHOD_TYPE:                    'payment_method_type', // s231
  FREQUENCY:                              'frequency',
  INC_TYPE:                               'inc_type',
  PAYMENT:                                'payment',
  RATE:                                   'rate',
  SOURCE:                                 'source',
  PENSION_DEATH_HANDLING:                 'pension_death_handling', // s232 Income (D-232.90(2))
  SURVIVOR_BENEFIT:                       'survivor_benefit',       // s232
  SURVIVOR_RECIPIENT:                     'survivor_recipient',     // s232
  STATUS:                                 'status',
  TAX_TYPE:                               'tax_type',
  TAX_YEAR:                               'tax_year',

  // ─── Financial — business ─────────────────────────────────────────────────
  ACCOUNTANT:                             'accountant',
  BIZ_NAME:                               'biz_name',
  BIZ_TYPE:                               'biz_type',

  // ─── Assets — properties ─────────────────────────────────────────────────
  DEED_LOCATION:                          'deed_location',
  LENDER:                                 'lender',
  MORTGAGE_ACCOUNT_NUMBER:                'mortgage_account_number',
  MORTGAGE_BALANCE:                       'mortgage_balance',  // s231 D-231.13(2): the property's secured debt
  LOAN_BALANCE:                           'loan_balance',      // s231 D-231.13(2): the vehicle's secured debt
  MORTGAGE_BAL:                           'mortgage_bal',
  MORTGAGES:                              'mortgages',
  PROP_TYPE:                              'prop_type',
  PROPERTY_INSURANCE:                     'property_insurance',
  ROLL_NUMBER:                            'roll_number',
  // s230 PhysicalAsset: the vehicle and property fields the typed map names.
  REGISTRATION_NUMBER:                    'registration_number',
  REGISTRATION_EXPIRY:                    'registration_expiry',
  REGISTERED_OWNER:                       'registered_owner',
  REGISTRATION_TYPE:                      'registration_type',
  LEGAL_DESCRIPTION:                      'legal_description',
  PROPERTY_FORM:                          'property_form',
  // s232 (chapter two, PR B): the interview's answers that had no field. Properties, vehicles and valuables share
  // LEFT_TO / LEFT_TO_PERSON ("Left to someone?", rule 55); the lender, payment and co-borrower live on the secured debt.
  LEFT_TO:                                'left_to',
  LEFT_TO_PERSON:                         'left_to_person',
  JOINT_GIFT_INTENT:                      'joint_gift_intent',
  HAS_MORTGAGE:                           'has_mortgage',
  MORTGAGE_LENDER:                        'mortgage_lender',
  MORTGAGE_PAYMENT:                       'mortgage_payment',
  MORTGAGE_CO_BORROWER:                   'mortgage_co_borrower',
  MORTGAGE_INSURED:                       'mortgage_insured',
  TENANT_NAME:                            'tenant_name',
  LAST_MONTH_DEPOSIT_TAKEN:               'last_month_deposit_taken',
  // s234 (CH2-STORAGE-PR3, D-233.70(3)): Properties' "Rented out?" (IS_RESIDENCE is shared with Things I Rent — per section).
  RENTED_OUT:                             'rented_out',
  HAS_LOAN:                               'has_loan',
  LOAN_LENDER:                            'loan_lender',
  LOAN_PAYMENT:                           'loan_payment',
  LOAN_CO_BORROWER:                       'loan_co_borrower',
  // s232 (chapter two): Things I Rent — the place the planner lives, its co-tenant, lease kind, deposits, a residence's name.
  IS_RESIDENCE:                           'is_residence',
  CO_TENANT:                              'co_tenant',
  LEASE_TERM:                             'lease_term',
  LAST_MONTH_DEPOSIT_PAID:                'last_month_deposit_paid',
  PREPAID_DEPOSIT:                        'prepaid_deposit',
  RESIDENCE_NAME:                         'residence_name',
  // s233 (D-233.35(1)): the residence as a business contact — its phone and email are the contact's own.
  RESIDENCE_PHONE:                        'residence_phone',
  RESIDENCE_EMAIL:                        'residence_email',
  // s232 (chapter two PR C): Firearms (valuables rows, category Firearms — ruling 3) and Safes and Locked Places (ruling 4).
  FIREARM_KIND:                           'firearm_kind',
  LEGAL_TAKER:                            'legal_taker',
  IN_LOCKED_STORAGE:                      'in_locked_storage',
  PLACE_KIND:                             'place_kind',
  CONTENTS:                               'contents',
  LOCK_KIND:                              'lock_kind',
  OPENER:                                 'opener',
  TITLE_OWNERSHIP:                        'title_ownership',
  // s235 PR A (rule 63, D-235.33): chapter two's contact cards carry Mobile · Email · an address. Each is the linked person's
  // own column (persons.primary_phone / primary_email / address), reached through the row's link — never a second copy.
  JOINT_OWNER_PHONE:                      'joint_owner_phone',
  JOINT_OWNER_EMAIL:                      'joint_owner_email',
  JOINT_OWNER_ADDRESS:                    'joint_owner_address',
  TENANT_PHONE:                           'tenant_phone',
  TENANT_EMAIL:                           'tenant_email',
  TENANT_ADDRESS:                         'tenant_address',
  LEFT_TO_PERSON_PHONE:                   'left_to_person_phone',
  LEFT_TO_PERSON_EMAIL:                   'left_to_person_email',
  LEFT_TO_PERSON_ADDRESS:                 'left_to_person_address',
  MORTGAGE_CO_BORROWER_PHONE:             'mortgage_co_borrower_phone',
  MORTGAGE_CO_BORROWER_EMAIL:             'mortgage_co_borrower_email',
  MORTGAGE_CO_BORROWER_ADDRESS:           'mortgage_co_borrower_address',
  LOAN_CO_BORROWER_PHONE:                 'loan_co_borrower_phone',
  LOAN_CO_BORROWER_EMAIL:                 'loan_co_borrower_email',
  LOAN_CO_BORROWER_ADDRESS:               'loan_co_borrower_address',
  LEGAL_TAKER_PHONE:                      'legal_taker_phone',
  LEGAL_TAKER_EMAIL:                      'legal_taker_email',
  LEGAL_TAKER_ADDRESS:                    'legal_taker_address',
  OPENER_PHONE:                           'opener_phone',
  OPENER_EMAIL:                           'opener_email',
  OPENER_ADDRESS:                         'opener_address',
  CO_TENANT_PHONE:                        'co_tenant_phone',
  CO_TENANT_EMAIL:                        'co_tenant_email',
  CO_TENANT_ADDRESS:                      'co_tenant_address',
  LANDLORD_ADDRESS:                       'landlord_address',
  RESIDENCE_ADDRESS:                      'residence_address',
  // s235 PR B (rule 150, D-235.18(3), D-235.20(4), findings item 63): chapter two's company cards — the lender, the insurer
  // and the broker (a person record each, by reference; their details are the person's own columns), "Is there insurance?",
  // who the planner deals with, and the person to ask for at every company (the landlord, the residence, the lender, the
  // insurer, the broker).
  MORTGAGE_LENDER_PHONE:                  'mortgage_lender_phone',
  MORTGAGE_LENDER_EMAIL:                  'mortgage_lender_email',
  MORTGAGE_LENDER_ADDRESS:                'mortgage_lender_address',
  MORTGAGE_LENDER_ASK_FOR:                'mortgage_lender_ask_for',
  MORTGAGE_LENDER_ASK_FOR_PHONE:          'mortgage_lender_ask_for_phone',
  MORTGAGE_LENDER_ASK_FOR_EMAIL:          'mortgage_lender_ask_for_email',
  MORTGAGE_LENDER_ASK_FOR_ADDRESS:        'mortgage_lender_ask_for_address',
  LOAN_LENDER_PHONE:                      'loan_lender_phone',
  LOAN_LENDER_EMAIL:                      'loan_lender_email',
  LOAN_LENDER_ADDRESS:                    'loan_lender_address',
  LOAN_LENDER_ASK_FOR:                    'loan_lender_ask_for',
  LOAN_LENDER_ASK_FOR_PHONE:              'loan_lender_ask_for_phone',
  LOAN_LENDER_ASK_FOR_EMAIL:              'loan_lender_ask_for_email',
  LOAN_LENDER_ASK_FOR_ADDRESS:            'loan_lender_ask_for_address',
  HAS_INSURANCE:                          'has_insurance',
  POLICY_INSURER:                         'policy_insurer',
  POLICY_INSURER_PHONE:                   'policy_insurer_phone',
  POLICY_INSURER_EMAIL:                   'policy_insurer_email',
  POLICY_INSURER_ADDRESS:                 'policy_insurer_address',
  POLICY_INSURER_ASK_FOR:                 'policy_insurer_ask_for',
  POLICY_INSURER_ASK_FOR_PHONE:           'policy_insurer_ask_for_phone',
  POLICY_INSURER_ASK_FOR_EMAIL:           'policy_insurer_ask_for_email',
  POLICY_INSURER_ASK_FOR_ADDRESS:         'policy_insurer_ask_for_address',
  POLICY_DEALT_WITH:                      'policy_dealt_with',
  POLICY_BROKER:                          'policy_broker',
  POLICY_BROKER_PHONE:                    'policy_broker_phone',
  POLICY_BROKER_EMAIL:                    'policy_broker_email',
  POLICY_BROKER_ADDRESS:                  'policy_broker_address',
  POLICY_BROKER_ASK_FOR:                  'policy_broker_ask_for',
  POLICY_BROKER_ASK_FOR_PHONE:            'policy_broker_ask_for_phone',
  POLICY_BROKER_ASK_FOR_EMAIL:            'policy_broker_ask_for_email',
  POLICY_BROKER_ASK_FOR_ADDRESS:          'policy_broker_ask_for_address',
  LANDLORD_ASK_FOR:                       'landlord_ask_for',
  LANDLORD_ASK_FOR_PHONE:                 'landlord_ask_for_phone',
  LANDLORD_ASK_FOR_EMAIL:                 'landlord_ask_for_email',
  LANDLORD_ASK_FOR_ADDRESS:               'landlord_ask_for_address',
  RESIDENCE_ASK_FOR:                      'residence_ask_for',
  RESIDENCE_ASK_FOR_PHONE:                'residence_ask_for_phone',
  RESIDENCE_ASK_FOR_EMAIL:                'residence_ask_for_email',
  RESIDENCE_ASK_FOR_ADDRESS:              'residence_ask_for_address',

  // ─── Assets — vehicles ───────────────────────────────────────────────────
  INS_PHONE:                              'ins_phone',
  INS_POLICY:                             'ins_policy',
  KEY_LOCATION:                           'key_location',
  LOAN_LEASE:                             'loan_lease',
  MAKE_MODEL:                             'make_model',
  PLATE:                                  'plate',
  REG_LOCATION:                           'reg_location',
  VEHICLE_LOCATION:                       'vehicle_location',
  PAPERS_LOCATION:                        'papers_location', // s233 (D-233.37): where a vehicle's papers are kept
  ACCOUNTANT_NAME:                        'accountant_name', // financial-taxes — the home's accountant card (s233)
  ACCOUNTANT_PHONE:                       'accountant_phone',
  ACCOUNTANT_EMAIL:                       'accountant_email', // s233 (D-233.74): the card's email box
  VEHICLE_TYPE:                           'vehicle_type',
  VIN:                                    'vin',

  // ─── Assets — valuables / digital ────────────────────────────────────────
  ASSET:                                  'asset',
  EXCHANGE:                               'exchange',
  WALLET_TYPE:                            'wallet_type',

  // ─── Insurance ───────────────────────────────────────────────────────────
  CONTACT_PHONE:                          'contact_phone',
  COVERAGE_AMOUNT:                        'coverage_amount',
  INSURANCE_PROVIDER:                     'insurance_provider',
  INSURANCE_TYPE:                         'insurance_type',
  INSURED:                                'insured',
  INSURER:                                'insurer',
  PLAN_TYPE:                              'plan_type',
  POLICY_LOCATION:                        'policy_location',
  POLICY_NUM:                             'policy_num',
  POLICY_NUMBER:                          'policy_number',
  POLICY_TYPE:                            'policy_type',
  PREMIUM:                                'premium',
  RENEWAL_DATE:                           'renewal_date',

  // ─── Financial — pre-authorized debits ───────────────────────────────────
  // s213 (CB-1): promoted from a bare literal. It is a Category B identifier, and the Cat B
  // declaration must name its fields through constants like every other slug-bearing surface.
  ACCOUNT_OR_MEMBER_NUMBER:               'account_or_member_number',

  // ─── Online presence / password log ──────────────────────────────────────
  ACCOUNT_NUMBER:                         'account_number',
  AUTOPAY:                                'autopay',
  NOTES_DOCS:                             'notes_docs',
  PASSWORD:                               'password',
  PAYMENT_METHOD:                         'payment_method',
  PIN:                                    'pin',
  SECURITY_QA:                            'security_qa',
  SITE_APP:                               'site_app',
  USERNAME:                               'username',

  // ─── Government IDs ───────────────────────────────────────────────────────
  EXPIRY:                                 'expiry',
  ID_NUMBER:                              'id_number',
  ID_TYPE:                                'id_type',
  PERSON_NAME:                            'person_name',
  ISSUING_AUTHORITY:                      'issuing_authority',
  PASSPORT_NUMBER:                        'passport_number',
  BIRTH_CERTIFICATE_NUMBER:               'birth_certificate_number',
  SIN:                                    'sin',

  // ─── Dependents ───────────────────────────────────────────────────────────
  ACTIVITIES:                             'activities',
  ALLERGIES:                              'allergies',
  BACKUP_GUARDIAN:                        'backup_guardian',
  // s221 Lane 1c: the contact card writes the guardian's, doctor's and school's details to these row fields.
  BACKUP_GUARDIAN_ADDRESS:                'backup_guardian_address',
  BACKUP_GUARDIAN_EMAIL:                  'backup_guardian_email',
  BACKUP_GUARDIAN_PHONE:                  'backup_guardian_phone',
  DOCTOR_ADDRESS:                         'doctor_address',
  DOCTOR_PHONE:                           'doctor_phone',
  PRIMARY_GUARDIAN_ADDRESS:               'primary_guardian_address',
  PRIMARY_GUARDIAN_EMAIL:                 'primary_guardian_email',
  PRIMARY_GUARDIAN_PHONE:                 'primary_guardian_phone',
  SCHOOL_ADDRESS:                         'school_address',
  SCHOOL_CONTACT_PERSON:                  'school_contact_person',
  SCHOOL_PHONE:                           'school_phone',
  CITIZENSHIP:                            'citizenship',
  CARE_NOTES:                             'care_notes',
  CONDITIONS:                             'conditions',
  CRITERIA:                               'criteria',
  DOB:                                    'dob',
  DOCTOR:                                 'doctor',
  DOCTOR_NAME:                            'doctor_name',
  GRADE:                                  'grade',
  GUARDIAN:                               'guardian',
  GUARDIAN_NAMED_IN_WILL:                 'guardian_named_in_will', // s221 Lane 1 (D-221.11)
  HAS_CARE_INFO:                          'has_care_info',
  HAS_EDUCATION_INFO:                     'has_education_info',
  HAS_GUARDIANSHIP_INFO:                  'has_guardianship_info',
  HAS_HEALTH_INFO:                        'has_health_info',
  IDENTITY_NOTES:                         'identity_notes',
  LEARNING_NEEDS:                         'learning_needs',
  MEDICATIONS:                            'medications',
  PERSON_KIND:                            'person_kind', // s221 Lane 1 (D-221.10): Child or Dependant
  PRIMARY_GUARDIAN:                       'primary_guardian',
  RAISED_IN_FAITH:                        'raised_in_faith', // s221 Lane 1 (Reade's GO ruling 3)
  // s221 CONTACT-CARD-ONE-1: one contact card for everyone — the fields each card was missing.
  PERSON_PHONE:                           'person_phone',
  PERSON_EMAIL:                           'person_email',
  PERSON_ADDRESS:                         'person_address',
  DOCTOR_EMAIL:                           'doctor_email',
  SCHOOL_EMAIL:                           'school_email',
  SCHOOL_CONTACT_PHONE:                   'school_contact_phone',
  SCHOOL_CONTACT_EMAIL:                   'school_contact_email',
  SCHOOL_CONTACT_ADDRESS:                 'school_contact_address',
  RELIGION:                               'religion',
  ROUTINES:                               'routines',
  SCHOOL:                                 'school',
  SCHOOL_NAME:                            'school_name',
  SPECIAL_NEEDS:                          'special_needs',

  // ─── Pets ─────────────────────────────────────────────────────────────────
  BREED:                                  'breed',
  PET_NAME:                               'pet_name',
  PET_TYPE:                               'pet_type',
  // s224 (D-223.36): the board models the vet as its OWN ROW in the second table, so `family-pets`
  // gains a kind column exactly as `children-dependents-overview` did (D-221.10, `person_kind`).
  ROW_KIND:                               'row_kind',
  // s224 CONTACT-CARD-ONE-1: the board's `who` cell ("Who would take them?") is the ONE standard
  // contact card, so the guardian gains the same three answers every other card keeps.
  GUARDIAN_PHONE:                         'guardian_phone',
  GUARDIAN_EMAIL:                         'guardian_email',
  GUARDIAN_ADDRESS:                       'guardian_address',
  // s224 (D-223.36): the vet ROW's own fields. `vet`, `vet_phone`, `vet_email` and `vet_address`
  // were four columns on EVERY pet row — four copies of one organisation, which is the thing
  // D-202.1 exists to stop. They are RETIRED, not renamed; these are the row's replacements.
  VET_PRACTICE:                           'vet_practice',
  VET_CONTACT:                            'vet_contact',
  VET_CONTACT_PHONE:                      'vet_contact_phone',
  VET_CONTACT_EMAIL:                      'vet_contact_email',
  VET_CONTACT_ADDRESS:                    'vet_contact_address',
  VET_ASK_FOR:                            'vet_ask_for',
  VET_ASK_FOR_PHONE:                      'vet_ask_for_phone',
  VET_ASK_FOR_EMAIL:                      'vet_ask_for_email',
  VET_ASK_FOR_ADDRESS:                    'vet_ask_for_address',

  // ─── Housing ──────────────────────────────────────────────────────────────
  HOUSING_TYPE:                           'housing_type',
  LANDLORD:                               'landlord',
  LANDLORD_EMAIL:                         'landlord_email',
  LANDLORD_PHONE:                         'landlord_phone',
  LEASE_END:                              'lease_end',
  LEASE_START:                            'lease_start',
  MONTHLY_RENT:                           'monthly_rent',
  RENTAL_ADDRESS:                         'rental_address',
  SECURITY_DEPOSIT:                       'security_deposit',

  // ─── Education / career ───────────────────────────────────────────────────
  CRED_TYPE:                              'cred_type',
  DEGREE:                                 'degree',
  EMPLOYER:                               'employer',
  EMPLOYER_ADDRESS:                       'employer_address',
  EMPLOYMENT_STATUS:                      'employment_status',
  END_YEAR:                               'end_year',
  FIELD_OF_STUDY:                         'field_of_study',
  GRADUATION_YEAR:                        'graduation_year',
  HR_CONTACT_EMAIL:                       'hr_contact_email',
  HR_CONTACT_NAME:                        'hr_contact_name',
  HR_CONTACT_PHONE:                       'hr_contact_phone',
  JOB_TITLE:                              'job_title',
  ORGANIZATION:                           'organization',
  START_YEAR:                             'start_year',

  // ─── Documents ────────────────────────────────────────────────────────────
  DATE_INFO:                              'date_info',
  DATE_SIGNED:                            'date_signed',
  LAST_UPDATED:                           'last_updated', // s233 (D-233.37): the will's "last updated" choice
  DATE_WRITTEN:                           'date_written',
  DOC_LOCATION:                           'doc_location',
  DOC_TYPE:                               'doc_type',
  DOCUMENT:                               'document',
  EXPIRES:                                'expires',
  FUNDED:                                 'funded',

  // ─── Letters / estate contacts ────────────────────────────────────────────
  LETTER_FILE:                            'letter_file',
  PAYEE:                                  'payee',
  RECIPIENT:                              'recipient',

  // ─── My wishes / contacts ─────────────────────────────────────────────────
  CONTACT:                                'contact',
  FIRM:                                   'firm',
  TOPIC:                                  'topic',
  WISHES:                                 'wishes',
  PREPAID:                                'prepaid',                // s233 Wish (D-233.32(1))
  BURIAL_CREMATION:                       'burial_cremation',       // s233
  FUNERAL_HOME_NAME:                      'funeral_home_name',      // s233 (D-233.32(2))
  CONTACT_EMAIL:                          'contact_email',          // s233
  CONTACT_ADDRESS:                        'contact_address',        // s233
  RECIPIENT_PHONE:                        'recipient_phone',        // s233 (D-233.32(3))
  RECIPIENT_EMAIL:                        'recipient_email',        // s233
  RECIPIENT_ADDRESS:                      'recipient_address',      // s233
  CONTACT_NAME:                           'contact_name',           // s233 Where Are They? (D-233.44(3))
  SUCCESSION_AGREEMENT:                   'succession_agreement',   // s233 Business (D-233.44(6))
  AGREEMENT_LOCATION:                     'agreement_location',     // s233
  SUCCESSION_CONTACT:                     'succession_contact',     // s233
  RECORDS_LOCATION:                       'records_location',       // s233 Taxes (D-233.80)

  // ─── Cloud storage / digital files ───────────────────────────────────────
  ACCOUNT_EMAIL:                          'account_email',
  CONTENTS_SUMMARY:                       'contents_summary',

  // ─── Common — shared across multiple section types ────────────────────────
  ACCOUNT:                                'account',
  ADDRESS:                                'address',
  BENEFICIARY:                            'beneficiary',
  CATEGORY:                               'category',
  COVERAGE:                               'coverage',
  DESCRIPTION:                            'description',
  DETAILS:                                'details',
  EMAIL:                                  'email',
  INSURANCE:                              'insurance',
  ITEM:                                   'item',
  LOCATION:                               'location',
  NAME:                                   'name',
  NOTES:                                  'notes',
  PHONE:                                  'phone',
  PROVIDER:                               'provider',
  RELATIONSHIP:                           'relationship',
  ROLE:                                   'role',
  TYPE:                                   'type',
  VALUE:                                  'value',
  YEAR:                                   'year',
  // s237 chapter three PR 2 (the Work screen; plan W6, W8, W15, W16, W18): Career and Business fields the interview binds.
  EMPLOYER_PHONE:                         'employer_phone',
  EMPLOYER_EMAIL:                         'employer_email',
  EMPLOYEE_NUMBER:                        'employee_number',
  CAREER_KIND:                            'career_kind',
  HR_CONTACT_ADDRESS:                     'hr_contact_address',
  BUSINESS_KIND:                          'business_kind',
  SUCCESSION_CONTACT_PHONE:               'succession_contact_phone',
  SUCCESSION_CONTACT_EMAIL:               'succession_contact_email',
  SUCCESSION_CONTACT_ADDRESS:             'succession_contact_address',
  CO_OWNER_2:                             'co_owner_2',
  CO_OWNER_2_PHONE:                       'co_owner_2_phone',
  CO_OWNER_2_EMAIL:                       'co_owner_2_email',
  CO_OWNER_2_ADDRESS:                     'co_owner_2_address',
  CO_OWNER_3:                             'co_owner_3',
  CO_OWNER_3_PHONE:                       'co_owner_3_phone',
  CO_OWNER_3_EMAIL:                       'co_owner_3_email',
  CO_OWNER_3_ADDRESS:                     'co_owner_3_address',
} as const;

export type FieldKey = typeof FIELD_KEYS[keyof typeof FIELD_KEYS];
